import React, { FC, useContext } from "react";
import {
  ClaimsInsightsDashboardContext,
  ClaimsInsightsDashboardContextProvider,
  ClaimsInsightsDashboardDefaultView,
  ClaimsInsightsDashboardScenarioView,
} from "@app/projects/network-assessment/pci-dashboard/claims-insights";
import { PciDashboardFilters, PciDashboardFiltersContext, PciDashboardFiltersContextProvider, PciDashboardWrapper } from "@app/projects/network-assessment/pci-dashboard/shared";

const WrappedClaimsInsightsDashboard: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsInsightsContext = useContext(ClaimsInsightsDashboardContext);
  const pciDashboardFiltersContext = useContext(PciDashboardFiltersContext);

  return (
    <PciDashboardWrapper>
      <PciDashboardFilters
        isLoading={
          claimsInsightsContext.marketProvidersEffectivenessLoading ||
          claimsInsightsContext.marketProvidersEfficiencyLoading ||
          claimsInsightsContext.networkProvidersEffectivenessLoading ||
          claimsInsightsContext.networkProvidersEfficiencyLoading ||
          claimsInsightsContext.prospectProvidersEffectivenessLoading ||
          claimsInsightsContext.prospectProvidersEfficiencyLoading ||
          claimsInsightsContext.countySummariesLoading ||
          claimsInsightsContext.specialtySummariesLoading
        }
        isPca={false}
        onApplyFiltersClick={claimsInsightsContext.onApplyFiltersClick}
        showLineOfBusiness={false}
      />
      {pciDashboardFiltersContext?.displayedFilters?.compareTimeslices ? (
        <ClaimsInsightsDashboardScenarioView />
      ) : (
        !claimsInsightsContext.showDashboardDetails && <ClaimsInsightsDashboardDefaultView />
      )}
    </PciDashboardWrapper>
  );
}

const ClaimsInsightsDashboard: FC = () => (
  <PciDashboardFiltersContextProvider>
    <ClaimsInsightsDashboardContextProvider>
      <WrappedClaimsInsightsDashboard />
    </ClaimsInsightsDashboardContextProvider>
  </PciDashboardFiltersContextProvider>
);

export default ClaimsInsightsDashboard;
